const DEFAULT_WORDS_COUNT = 200;
const COUNT_DOWN_150 = 150;
const COUNT_DOWN_120 = 120;
const COUNT_DOWN_90 = 90;
const COUNT_DOWN_60 = 60;
const COUNT_DOWN_30 = 30;
const COUNT_DOWN_15 = 15;
const DEFAULT_COUNT_DOWN = COUNT_DOWN_60;



const DEFAULT_DIFFICULTY = "Dhex-dhexaad";
const HARD_DIFFICULTY = "Adag";
const NUMBER_ADDON = "+Tirooyin";
const SYMBOL_ADDON = "+Symbol";
const RESTART_BUTTON_TOOLTIP_TITLE = "";
const REDO_BUTTON_TOOLTIP_TITLE = "";
const RESTART_BUTTON_TOOLTIP_TITLE_WORDSCARD =
  "";
const SELECT_ONE_OR_MORE_CHAPTERS =
  "Open to select one or more chapters. Pick the chapters in the typing area.";
const RECITE_MODE_TITLE = "hide the word (默写模式)";
const DEFAULT_DIFFICULTY_TOOLTIP_TITLE =
  "";
const HARD_DIFFICULTY_TOOLTIP_TITLE =
  "";
const NUMBER_ADDON_TOOLTIP_TITLE =
  "";
const SYMBOL_ADDON_TOOLTIP_TITLE =
  "";
const CHAR_TOOLTIP_TITLE =
  "";
const SENTENCE_CHAR_TOOLTIP_TITLE = "correct/incorrect/extra\n";
const ENGLISH_MODE_TOOLTIP_TITLE = "English";
const CHINESE_MODE_TOOLTIP_TITLE = "Chinese";
const SOMALI_MODE_TOOLTIP_TITLE = "Somali";
const DEFAULT_DIFFICULTY_TOOLTIP_TITLE_CHINESE =
  "";
const HARD_DIFFICULTY_TOOLTIP_TITLE_CHINESE =
  "";

  const DEFAULT_DIFFICULTY_TOOLTIP_TITLE_SOMALI =
  "";
const HARD_DIFFICULTY_TOOLTIP_TITLE_SOMALI =
  "";

const GITHUB_TOOLTIP_TITLE =
  "Waxaa website-kan dib u dhisay, oo dayac-tiray MAREEGE.COM. \n \n This website has been rebuilt and maintained by MAREEGE.COM \n";
const SUPPORT_TOOLTIP_TITLE =
  "Wixii aad awoodo website-kan ku deeqi.\n";
const AUTHOR = "👉: MAREEGE.COM \n";
const GITHUB_REPO_LINK = "project: @Github\n";

const FOCUS_MODE = "";

const ULTRA_ZEN_MODE = "";

const MUSIC_MODE =
  "";
const FREE_MODE =
  "";

const ENGLISH_MODE = "ENGLISH_MODE";
const CHINESE_MODE = "CHINESE_MODE";
const SOMALI_MODE = "SOMALI_MODE";



const GAME_MODE = "GAME_MODE";
const GAME_MODE_DEFAULT = "WORD_MODE";
const GAME_MODE_SENTENCE = "SENTENCE_MODE";
const WORD_MODE_LABEL = "Ereyo";
const SENTENCE_MODE_LABEL = "Odhaahyo";
const TRAINER_MODE = "";

const DEFAULT_SENTENCES_COUNT = 15;
const TEN_SENTENCES_COUNT = 10;
const FIVE_SENTENCES_COUNT = 5;
const TWENTY_SENTENCES_COUNT = 20;
const TWENTY_FIVE_SENTENCES_COUNT = 25;
const THIRTY_SENTENCES_COUNT = 30;

const ENGLISH_SENTENCE_MODE_TOOLTIP_TITLE = "English";
const CHINESE_SENTENCE_MODE_TOOLTIP_TITLE = "Chinese";
const SOMALI_SENTENCE_MODE_TOOLTIP_TITLE = "Somali";

const WORDS_CARD_MODE = "";

const PACING_CARET = "Taag";
const PACING_PULSE = "Jiif";

const PACING_CARET_TOOLTIP =
  '';
const PACING_PULSE_TOOLTIP =
  '';

const NUMBER_ADDON_KEY = "number";
const SYMBOL_ADDON_KEY = "symbol";



export {
  DEFAULT_WORDS_COUNT,
  DEFAULT_COUNT_DOWN,
  COUNT_DOWN_150,
  COUNT_DOWN_120,
  COUNT_DOWN_90,
  COUNT_DOWN_60,
  COUNT_DOWN_30,
  COUNT_DOWN_15,
  DEFAULT_DIFFICULTY,
  HARD_DIFFICULTY,
  NUMBER_ADDON,
  SYMBOL_ADDON,
  DEFAULT_DIFFICULTY_TOOLTIP_TITLE,
  HARD_DIFFICULTY_TOOLTIP_TITLE,
  NUMBER_ADDON_TOOLTIP_TITLE,
  SYMBOL_ADDON_TOOLTIP_TITLE,
  CHAR_TOOLTIP_TITLE,
  SENTENCE_CHAR_TOOLTIP_TITLE,
  GITHUB_TOOLTIP_TITLE,
  SUPPORT_TOOLTIP_TITLE,
  FOCUS_MODE,
  MUSIC_MODE,
  ENGLISH_MODE,
  CHINESE_MODE,
  SOMALI_MODE,
  RESTART_BUTTON_TOOLTIP_TITLE,
  REDO_BUTTON_TOOLTIP_TITLE,
  ENGLISH_MODE_TOOLTIP_TITLE,
  CHINESE_MODE_TOOLTIP_TITLE,
  SOMALI_MODE_TOOLTIP_TITLE,
  DEFAULT_DIFFICULTY_TOOLTIP_TITLE_CHINESE,
  HARD_DIFFICULTY_TOOLTIP_TITLE_CHINESE,
  DEFAULT_DIFFICULTY_TOOLTIP_TITLE_SOMALI,
  HARD_DIFFICULTY_TOOLTIP_TITLE_SOMALI,
  FREE_MODE,
  GAME_MODE,
  GAME_MODE_DEFAULT,
  GAME_MODE_SENTENCE,
  WORD_MODE_LABEL,
  SENTENCE_MODE_LABEL,
  FIVE_SENTENCES_COUNT,
  TEN_SENTENCES_COUNT,
  DEFAULT_SENTENCES_COUNT,
  TWENTY_SENTENCES_COUNT,
  TWENTY_FIVE_SENTENCES_COUNT,
  THIRTY_SENTENCES_COUNT,
  ENGLISH_SENTENCE_MODE_TOOLTIP_TITLE,
  CHINESE_SENTENCE_MODE_TOOLTIP_TITLE,
  SOMALI_SENTENCE_MODE_TOOLTIP_TITLE,
  AUTHOR,
  GITHUB_REPO_LINK,
  TRAINER_MODE,
  WORDS_CARD_MODE,
  RESTART_BUTTON_TOOLTIP_TITLE_WORDSCARD,
  SELECT_ONE_OR_MORE_CHAPTERS,
  RECITE_MODE_TITLE,
  PACING_CARET,
  PACING_PULSE,
  PACING_CARET_TOOLTIP,
  PACING_PULSE_TOOLTIP,
  NUMBER_ADDON_KEY,
  SYMBOL_ADDON_KEY,
  ULTRA_ZEN_MODE,
};
